import http from "../../../network/HTTPClient";

const SettingRepository = {
  async get(data) {
    const response = await http.post("setting/get", data);
    return response.data;
  },
  async set(data) {
    const response = await http.post("setting/set", data);
    return response.data;
  },
};

export default SettingRepository;
